<div class="overflow-hidden d-flex flex-column align-items-center">
  @if(categoryGroups.length > 0){ @for(categoryGroup of categoryGroups; track categoryGroup.uniqueId) { @if(categoryGroup.isActive){
  <div class="w-100 mx-auto group" [ngStyle]="getMainContainerStyle(categoryGroup)">
    @if(categoryGroup.headerFooterViewConfig.header.isShow) {
    <div class="position-relative" [ngStyle]="getHeaderStyle(categoryGroup)">
      @if(categoryGroup.headerFooterViewConfig.header.fullImage.url) {
      <img
        [src]="helper.imageUrl + categoryGroup.headerFooterViewConfig.header.fullImage.url"
        [ngStyle]="getImageStyle(categoryGroup.headerFooterViewConfig.header.fullImage)"
        alt="Full Image"
        class="w-100 mw-100 h-auto hide-on-large-screen"
      />
      } @else if (categoryGroup.headerFooterViewConfig.header.leftImage.url) {
      <img
        [src]="helper.imageUrl + categoryGroup.headerFooterViewConfig.header.leftImage.url"
        [ngStyle]="getImageStyle(categoryGroup.headerFooterViewConfig.header.leftImage)"
        [width]="categoryGroup.headerFooterViewConfig.header.leftImage.width"
        [height]="categoryGroup.headerFooterViewConfig.header.leftImage.height"
        alt="Left Image"
      />
      } @else if (categoryGroup.headerFooterViewConfig.header.rightImage.url){
      <img
        [src]="helper.imageUrl + categoryGroup.headerFooterViewConfig.header.rightImage.url"
        [ngStyle]="getImageStyle(categoryGroup.headerFooterViewConfig.header.rightImage)"
        [width]="categoryGroup.headerFooterViewConfig.header.rightImage.width"
        [height]="categoryGroup.headerFooterViewConfig.header.rightImage.height"
        alt="Right Image"
      />
      }
      <div
        [ngClass]="
          categoryGroup.headerFooterViewConfig.header.fullImage.url && !isDesktop
            ? 'position-absolute bottom-0 d-flex flex-column align-items-center w-100'
            : 'd-flex flex-column w-100'
        "
      >
        @if(categoryGroup.headerFooterViewConfig.header.title.text){
        <div class="d-flex justify-content-between">
          <span
            [ngStyle]="getTitleStyle(categoryGroup.headerFooterViewConfig.header.title)"
            [ngClass]="categoryGroup.childIds.length > categoryGroup.childs.length ? 'w-80' : 'w-100'"
          >
            {{ categoryGroup.headerFooterViewConfig.header.title.text | translate }}
          </span>
          @if(categoryGroup.childIds.length > categoryGroup.childs.length){
          <span [ngStyle]="getTitleStyle(categoryGroup.headerFooterViewConfig.header.title)" class="cursor-pointer" (click)="viewAll(categoryGroup)">{{
            "button-title.view-all" | translate
          }}</span>
          }
        </div>
        } @if(categoryGroup.headerFooterViewConfig.header.description.text){
        <p [ngStyle]="getDescriptionStyle(categoryGroup.headerFooterViewConfig.header.description)">
          {{ categoryGroup.headerFooterViewConfig.header.description.text | translate }}
        </p>
        }
      </div>
    </div>
    } @if (categoryGroup.childType === "CATEGORY") {
    <!-- Category Layout -->
    <div [ngStyle]="getCategoryContainerStyle(categoryGroup)">
      @if(isDesktop){
      <div [ngStyle]="getCategoryGridLayoutStyle(categoryGroup, false)" class="grid-container">
        @for (child of categoryGroup.childs; track child._id) {
        <ng-container *ngTemplateOutlet="categoryLayout; context: { categoryGroup: categoryGroup, child: child }"></ng-container>
        }
      </div>
      } @else {
      <!-- First row with remainder items -->
      @if(categoryGroup.childs.length % categoryGroup.gridViewConfig.maxColumnCount){
      <div [ngStyle]="getCategoryGridLayoutStyle(categoryGroup, true)" class="grid-container">
        @for (child of categoryGroup.childs.slice(0, categoryGroup.childs.length % categoryGroup.gridViewConfig.maxColumnCount); track child._id) {
        <ng-container *ngTemplateOutlet="categoryLayout; context: { categoryGroup: categoryGroup, child: child }"></ng-container>
        }
      </div>
      }
      <!-- Remaining rows with maxColumnCount items -->
      <div [ngStyle]="getCategoryGridLayoutStyle(categoryGroup, false)" class="grid-container">
        @for (child of categoryGroup.childs.slice(categoryGroup.childs.length % categoryGroup.gridViewConfig.maxColumnCount); track child._id) {
        <ng-container *ngTemplateOutlet="categoryLayout; context: { categoryGroup: categoryGroup, child: child }"></ng-container>
        }
      </div>
      }
    </div>
    } @else {
    <!-- Product layout -->
    <app-product-group
      [categoryGroup]="categoryGroup"
      [merchantId]="merchantId"
      [isCart]="isCart"
      [serviceMainCategory]="serviceMainCategory"
      [serviceMerchantId]="serviceMerchantId"
      [isBrandType]="isBrandType(categoryGroup)"
    ></app-product-group>
    } @if(categoryGroup.headerFooterViewConfig.footer.isShow) {
    <div class="position-relative" [ngStyle]="getFooterStyle(categoryGroup)">
      @if(categoryGroup.headerFooterViewConfig.footer.fullImage.url) {
      <img
        [src]="helper.imageUrl + categoryGroup.headerFooterViewConfig.footer.fullImage.url"
        [ngStyle]="getImageStyle(categoryGroup.headerFooterViewConfig.footer.fullImage)"
        alt="Full Image"
        class="w-100 mw-100 h-auto hide-on-large-screen"
      />
      } @else if (categoryGroup.headerFooterViewConfig.footer.leftImage.url) {
      <img
        [src]="helper.imageUrl + categoryGroup.headerFooterViewConfig.footer.leftImage.url"
        [ngStyle]="getImageStyle(categoryGroup.headerFooterViewConfig.footer.leftImage)"
        [width]="categoryGroup.headerFooterViewConfig.footer.leftImage.width"
        [height]="categoryGroup.headerFooterViewConfig.footer.leftImage.height"
        alt="Left Image"
      />
      } @else if (categoryGroup.headerFooterViewConfig.footer.rightImage.url){
      <img
        [src]="helper.imageUrl + categoryGroup.headerFooterViewConfig.footer.rightImage.url"
        [ngStyle]="getImageStyle(categoryGroup.headerFooterViewConfig.footer.rightImage)"
        [width]="categoryGroup.headerFooterViewConfig.footer.rightImage.width"
        [height]="categoryGroup.headerFooterViewConfig.footer.rightImage.height"
        alt="Right Image"
      />
      }
      <div
        [ngClass]="
          categoryGroup.headerFooterViewConfig.footer.fullImage.url && !isDesktop
            ? 'position-absolute bottom-0 d-flex flex-column align-items-center w-100'
            : 'd-flex flex-column w-100'
        "
      >
        @if(categoryGroup.headerFooterViewConfig.footer.title.text){
        <span [ngStyle]="getTitleStyle(categoryGroup.headerFooterViewConfig.footer.title)">
          {{ categoryGroup.headerFooterViewConfig.footer.title.text | translate }}
        </span>
        } @if(categoryGroup.headerFooterViewConfig.footer.description.text){
        <p [ngStyle]="getDescriptionStyle(categoryGroup.headerFooterViewConfig.footer.description)">
          {{ categoryGroup.headerFooterViewConfig.footer.description.text | translate }}
        </p>
        }
      </div>
    </div>
    }
  </div>
  } } }
</div>

<ng-template #categoryLayout let-categoryGroup="categoryGroup" let-child="child">
  @if(categoryGroup.gridChildViewConfig.title.position[0] === "INSIDE"){
  <div class="cursor-pointer" [ngStyle]="getGridItemStyle(categoryGroup)" (click)="goToList(child)">
    <!-- Render child content here -->
    @if (child.assets.length > 1) {
    <div class="row row-cols-2 g-1">
      @for (item of child.assets; track $index) {
      <div>
        <img
          [src]="item.url ? helper.imageUrl + item.url : 'assets/images/default-image.jpg'"
          [ngStyle]="getGridItemImageStyle(categoryGroup)"
          alt="Child Image"
          class="h-100 w-100 object-fit-cover"
        />
      </div>
      }
    </div>
    } @else {
    <div class="aspect-w-1 aspect-h-1">
      <img
        [src]="child.assets.length > 0 && child.assets[0].url ? helper.imageUrl + child.assets[0].url : 'assets/images/default-image.jpg'"
        [ngStyle]="getGridItemImageStyle(categoryGroup)"
        alt="Child Image"
        class="h-100 w-100 object-fit-cover img"
      />
    </div>
    }
    <span [ngStyle]="getTitleStyle(categoryGroup.gridChildViewConfig.title)">
      {{ child.name | translate }}
    </span>
  </div>
  } @if(categoryGroup.gridChildViewConfig.title.position[0] === "OUTSIDE"){
  <div class="d-flex" [ngClass]="categoryGroup.gridChildViewConfig.title.position[1] === 'BOTTOM' ? 'flex-column' : 'flex-column-reverse'">
    <div class="cursor-pointer" [ngStyle]="getGridItemStyle(categoryGroup)" (click)="goToList(child)">
      <!-- Render child content here -->
      @if (child.assets.length > 1) {
      <div class="row row-cols-2 g-1">
        @for (item of child.assets; track $index) {
        <div>
          <img
            [src]="item.url ? helper.imageUrl + item.url : 'assets/images/default-image.jpg'"
            [ngStyle]="getGridItemImageStyle(categoryGroup)"
            alt="Child Image"
            class="h-100 w-100 object-fit-cover"
          />
        </div>
        }
      </div>
      } @else {
      <div class="aspect-w-1 aspect-h-1">
        <img
          [src]="child.assets.length > 0 && child.assets[0].url ? helper.imageUrl + child.assets[0].url : 'assets/images/default-image.jpg'"
          [ngStyle]="getGridItemImageStyle(categoryGroup)"
          alt="Child Image"
          class="h-100 w-100 object-fit-cover img"
        />
      </div>
      }
    </div>
    <span [ngStyle]="getTitleStyle(categoryGroup.gridChildViewConfig.title)">
      {{ child.name | translate }}
    </span>
  </div>
  }
</ng-template>
